"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.for-each");

var _themeSections = require("@shopify/theme-sections");

var _debounce = _interopRequireDefault(require("lodash-es/debounce"));

var _flickityImagesloaded = _interopRequireDefault(require("flickity-imagesloaded"));

var _utils = require("../helpers/utils");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  siteHeaderInnerContainer: '[js-site-header="innerContainer"]',
  container: '[js-hero-banner="carousel"]',
  cell: '[js-hero-banner="slide"]',
  pagination: '[js-hero-banner="pagination"]',
  paginationButton: '[js-hero-banner="paginationButton"]',
  contentContainer: '[js-hero-banner="contentContainer"]'
};
/**
 * Register a single hero banner section.
 * Executes on page load as well as Theme Editor `section:load` events.
 * @param {string} container - Selector for the section container DOM element.
 */

(0, _themeSections.register)('hero-banner', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors: function cacheSelectors() {
    var container = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.container);
    var cells = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.cell);
    this.cache = {
      container: container,
      cells: cells
    };
  },

  /**
   * Set cached node selectors.
   */
  setNodeSelectors: function setNodeSelectors() {
    this.siteHeaderInnerContainer = document.querySelector(selectors.siteHeaderInnerContainer);
    this.container = document.querySelector(this.cache.container);
    this.cells = _toConsumableArray(document.querySelectorAll(this.cache.cells));
    this.contentContainers = document.querySelectorAll(selectors.contentContainer);
  },

  /**
   * Check if the section has enabled the slider option.
   */
  isSliderEnabled: function isSliderEnabled() {
    return document.querySelector(this.cache.container) !== null;
  },

  /**
   * Construct carousel.
   */
  constructCarousel: function constructCarousel() {
    var autoPlayValue = this.container.getAttribute('data-carousel-autoplay');
    var autoPlayNumber = parseInt(autoPlayValue, 0);
    var carousel = new _flickityImagesloaded["default"](this.cache.container, {
      autoPlay: autoPlayNumber,
      cellAlign: 'left',
      imagesLoaded: false,
      pageDots: false,
      prevNextButtons: true
    });

    if (this.cells.length === 1) {
      carousel.destroy();
    }

    this.updatePaginationButtonsActiveState(carousel);
    this.updatePaginationSlide(carousel);
    this.setListeners(carousel);
  },

  /**
   * Handle pagination button active state.
   * @param {Object} [carousel] - New Flickity instance.
   */
  updatePaginationButtonsActiveState: function updatePaginationButtonsActiveState(carousel) {
    this.cells.forEach(function (element) {
      var paginationElement = element.querySelector(selectors.pagination);
      carousel.on('select', function () {
        var previousSelectedButton = paginationElement.querySelector('.is-active');
        var selectedButton = paginationElement.children[carousel.selectedIndex];
        previousSelectedButton.classList.remove(_cssClasses["default"].active);
        selectedButton.classList.add(_cssClasses["default"].active);
      });
    });
  },

  /**
   * Construct pagination.
   * @param {Object} [carousel] - New Flickity instance.
   */
  updatePaginationSlide: function updatePaginationSlide(carousel) {
    var elements = this.container.querySelectorAll(selectors.paginationButton);
    elements.forEach(function (element) {
      element.addEventListener('click', function (event) {
        var target = event.target;
        var selector = target.getAttribute('data-selector');
        carousel.selectCell(selector);
      });
    });
  },

  /**
   * Position content.
   */
  positionContent: function positionContent() {
    if (!this.siteHeaderInnerContainer) {
      return;
    }

    var style = window.getComputedStyle(this.siteHeaderInnerContainer);
    this.contentContainers.forEach(function (element) {
      element.style.marginLeft = style.marginLeft;
    });
  },

  /**
   * Set listeners for each instance.
   * @param {Object} [carousel] - New Flickity instance.
   */
  setListeners: function setListeners(carousel) {
    Frame.EventBus.listen(['Toggle:menuDrawerTarget:open'], function () {
      return carousel.stopPlayer();
    });
    Frame.EventBus.listen(['Toggle:menuDrawerTarget:close'], function () {
      return carousel.playPlayer();
    });
    Frame.EventBus.listen(['Toggle:meganav:open'], function () {
      return carousel.stopPlayer();
    });
    Frame.EventBus.listen(['Toggle:meganav:close'], function () {
      return carousel.playPlayer();
    });
  },

  /**
   * Construct new carousel on `section:load`.
   */
  onLoad: function onLoad() {
    var _this = this;

    this.cacheSelectors();
    this.setNodeSelectors();

    if (this.isSliderEnabled()) {
      this.constructCarousel();
      this.positionContent();
      (0, _utils.on)('resize', (0, _debounce["default"])(function () {
        return _this.positionContent();
      }, 250));
    }
  }
});